export const dotenv = {
  API_BASE_URL: 'https://api-stg.mykinships.com',
  NOTIFICATION_BASE_URL: 'https://api-stg-notification.mykinships.com',
  FRONTEND_BASE_URL: 'https://app-stg.mykinships.com',
  MEDIA_BASE_URL: 'https://api-stg-media.mykinships.com',
  NODE_TLS_REJECT_UNAUTHORIZED: '0',
  BUCKET: 'mykinship-stg-assets',
  ENV: 'stg',
  CLOUD_FRONT_BASE_URL: 'https://d3t6eg1lrfe4lz.cloudfront.net/',
  ASSET_BASE_URL: 'https://mykinship-stg-assets.s3.us-west-1.amazonaws.com/',
  IS_SIGNUP_CODE_ENABLED: 'false',
  MARKETING_SITE_URL: 'https://stage.mykinships.com',
  SOCKET_URL: 'https://socket-stg.mykinships.com'
};
